import React, { useState, useEffect } from "react"
import { isPresentAuthenticatedUser, logout } from '../../utils/utilities'
import {
  Header,
  HeaderContent,
  HeaderBrand,
  HeaderRightZone,
  Button,
  Icon,
  HeaderSocialsZone
} from 'design-react-kit';
import * as Constants from '../../utils/constants'



import regioneLiguriaLogoSmall from "../../images/logoRLsmall.png"
import LogoutIcon from "./LogoutIcon";

export const SibaHeader = () => {
  const [utenteAttivo, setUtenteAttivo] = useState(Constants.EMPTY_STRING);

  useEffect(() => {
    if (isPresentAuthenticatedUser()) {
      setUtenteAttivo(sessionStorage.getItem(Constants.USER_IN_SESSION))
    }
  }, []);

  
  return (
    <div>
      <Header small={true} theme="" type="center" className="top siba-header-ente">
        <HeaderContent>
          <HeaderBrand responsive={true} tag="a" className="px-1 my-1">
              <strong>REGIONE LIGURIA</strong>
          </HeaderBrand>
          <HeaderBrand responsive={true} tag="a" className="px-1 my-1">
            {utenteAttivo !== Constants.EMPTY_STRING ?
              <div className="align-middle text-right">
                {/* STALIGK-822 <Button className="btn btn-dark" icon={false} size="xs" onClick={logout}> */}
                <Button className="btn btn-dark btn-logout" size="xs" icon onClick={logout}>
                 <LogoutIcon/> Logout {utenteAttivo}
                </Button>
              </div>
              : React.Fragment
            }
          </HeaderBrand>
        </HeaderContent>
      </Header>
      <Header small={true} theme="" type="center" className="top siba-header">  
      <HeaderContent>
          <HeaderBrand responsive={true} tag="a" className="px-1 my-1">
                  <a className="logo" href="http://www.regione.liguria.it" >
                    <img className="regione-logo-header" src={regioneLiguriaLogoSmall} alt="Logo Regione Liguria" />
                  </a>
          </HeaderBrand>
          <HeaderBrand responsive={true} tag="a" className="px-1 my-1 siba-header-center ">
                  <h1 className="text-dark text-uppercase font-weight-bold">
                      TASSA AUTOMOBILISTICA
                    </h1>
           </HeaderBrand>
           <HeaderBrand responsive={true} tag="a" className="px-1 my-1"></HeaderBrand>
          </HeaderContent> 
       </Header>
    </div>
  );
}

export default SibaHeader;